import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import System from "../views/System.vue";
import voipExtension from "./voipExtension"; // lee 分机管理
import PerformanceManagement from "./PerformanceManagement"; // lee 账期配置
import orderPage from "./orderPage"; // lee 工单
import DataModule from "./DataModule"; //信审管理
import phoneSaleDataModule from "./phoneSaleDataModule"; // 电销数据模块

import { localGet } from "@/utils/index";

Vue.use(VueRouter);

export const constantRouterMap: Array<any> = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/common/Login.vue")
  }
];

export let asyncRouterMap: Array<any> = [
  {
    path: "/system",
    name: "中台系统",
    component: System,
    meta: { name: "menu.CollectionSystem" },
    children: [
      {
        path: "/userManagementIndex",
        name: "权限系统",
        component: () =>
          import(
            /* webpackChunkName: "userManagementIndex" */ "../views/userManagement/index.vue"
          ),
        meta: { id: 50, hidden: true, name: "menu.AuthoritySystem" },
        children: [
          {
            path: "/userManagementV2",
            name: "用户管理",
            component: () =>
              import(
                /* webpackChunkName: "userManagementIndex" */ "../views/userManagement/UserManagementV2.vue"
              ),
            meta: { id: 51, hidden: true, name: "menu.UserManagement" }
          },
          {
            path: "/roleManagementV2",
            name: "角色管理",
            component: () =>
              import(
                /* webpackChunkName: "roleManagementV2" */ "../views/userManagement/RoleManagementV2.vue"
              ),
            meta: { id: 56, hidden: true, name: "menu.RoleManagement" }
          },
          {
            path: "/authorityManagementV2",
            name: "权限管理",
            component: () =>
              import(
                /* webpackChunkName: "authorityManagementV2" */ "../views/userManagement/AuthorityManagementV2.vue"
              ),
            meta: { id: 61, hidden: true, name: "menu.AuthorityManagement" }
          },
          {
            path: "/roleGroup",
            name: "角色组管理",
            component: () =>
              import(
                /* webpackChunkName: "roleGroup" */ "../views/userManagement/RoleGroup.vue"
              ),
            meta: { id: 64, hidden: true, name: "menu.RolegroupManagement" }
          },
          {
            path: "/authorityGroup",
            name: "组权限管理",
            component: () =>
              import(
                /* webpackChunkName: "authorityGroup" */ "../views/userManagement/AuthorityGroup.vue"
              ),
            meta: { id: 70, hidden: true, name: "menu.GroupRightsManagement" }
          },
          {
            path: "/resourceManagement",
            name: "资源管理",
            component: () =>
              import(
                /* webpackChunkName: "resourceManagement" */ "../views/userManagement/ResourceManagement.vue"
              ),
            meta: { hidden: true, name: "menu.GroupRightsManagement" }
          },
          {
            path: "/pageManagement",
            name: "页面管理",
            component: () =>
              import(
                /* webpackChunkName: "resourceManagement" */ "../views/userManagement/PageManagement.vue"
              ),
            meta: { id: 270, hidden: true, name: "menuLgy.PageManagement" }
          }
          ,
          {
            path: "/routeManagement",
            name: "路由管理",
            component: () =>
              import(
                /* webpackChunkName: "resourceManagement" */ "../views/userManagement/RouteManagement.vue"
              ),
            meta: { id: 265, hidden: true, name: "menuLgy.RouteManagement" }
          }
        ]
      },
      {
        path: "/peopleManagement",
        name: "人员需求管理",
        component: () =>
          import(
            "../views/peopleManagement/index.vue"
          ),
        meta: { id: '', hidden: true, name: "" }
      },
      {
        path: "/addPeopleInfo",
        name: "添加人员信息",
        component: () =>
          import(
            "../views/peopleManagement/addPeopleInfo.vue"
          ),
        meta: { id: '', hidden: true, name: "" }
      },
      {
        path: "/systemParaConfig",
        name: "系统参数配置",
        component: () =>
          import(
            /* webpackChunkName: "systemParaConfig" */ "../views/systemParaConfig/index.vue"
          ),
        meta: { id: 1, hidden: true, name: "menu.SystemParameterConfiguration" }
      },
      {
        path: "/phoneVerifySystem",
        name: "信审管理",
        component: () =>
          import(
            /* webpackChunkName: "caseClassification" */ "../views/phoneVerifySystem/index.vue"
          ),
        meta: { id: 245, hidden: true, name: "menu.PhoneVerifySystem" },
        children: [
          ...DataModule,
          {
            path: "/staffManagement",
            name: "员工管理",
            component: () =>
              import(
                "../views/phoneVerifySystem/StaffManagement.vue"
              ),
            meta: { id: 246, hidden: true, name: "menu.StaffManagement" }
          },
          {
            path: "/questionLibrary",
            name: "问题库配置",
            component: () =>
              import("@/views/questionLibrary/index.vue"),
            meta: { id: 251, hidden: true, name: "menu.QuestionLibraryConfig" },
          },
          {
            path: "/orderReview",
            name: "电核工单管理",
            component: () =>
              import("@/views/orderReview/index.vue"),
            meta: { id: 280, hidden: true, name: "menuFhb.auditStaffManagement" },
          },
          {
            path: "/verifyRules",
            // name: "电核分单",
            name: "分单管理",
            component: () =>
              import("@/views/verifyRules/index.vue"),
            meta: { id: 348, hidden: true, name: "ticketFhb.phoneVerifyDistribution" },
          },
          {
            path: "/orderPrgitocess",
            name: "工单处理",
            component: () =>
              import(
                "../views/orderProcess/index.vue"
              ),
            meta: { id: 360, hidden: true, name: "menuFhb.workOrderProcessingList" },
            children: [
              {
                path: "/auditOrderHandle",
                name: "信审工单处理",
                component: () =>
                  import("@/views/orderProcess/auditOrderHandle/index.vue"),
                meta: { id: 361, hidden: true, name: "menuFhb.creditApprovalTicketHandle" },
              },
              {
                path: "/inspectOrderManage",
                name: "质检工单处理",
                component: () =>
                  import("@/views/orderProcess/inspectOrderManage/index.vue"),
                meta: { id: 362, hidden: true, name: "menuFhb.qualityInspectionTicketHandle" },
              }
            ]
          },
          {
            path: "/auditDetail",
            name: "员工审核详情",
            component: () =>
              import(
                "@/views/phoneVerifySystem/auditDetail/index.vue"
              ),
            meta: { id: 40100, hidden: true, name: "menuLgy.EmployeeReviewDetails" }
          },
          {
            path: "/auditDetailMX",
            name: "员工审核详情MX",
            component: () =>
              import(
                "@/views/phoneVerifySystem/auditDetailMX/index.vue"
              ),
            meta: { id: 40100, hidden: true, name: "menuLgy.EmployeeReviewDetails" }
          },
          {
            path: "/customerReviewInfo",
            name: "客户审核信息",
            component: () =>
              import(
                "@/views/phoneVerifySystem/auditDetail/view/customerInformation/index.vue"
              ),
            meta: { id: 24600, hidden: true, name: "menuLgy.CustomerInformation" }
          }
        ]
      },
      {
        path: "/caseClassification",
        name: "案件分级",
        component: () =>
          import(
            /* webpackChunkName: "caseClassification" */ "../views/caseClassification/index.vue"
          ),
        meta: { id: 73, hidden: true, name: "menu.CaseClassification" }
      },
      {
        path: "/order",
        name: "催收工单系统",
        component: () =>
          import(/* webpackChunkName: "order" */ "../views/order/index.vue"),
        meta: { id: 5, hidden: true, name: "menu.CollectTicketSystem" },
        children: [
          {
            path: "/orderManagement",
            name: "工单管理",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/order/OrderManagement.vue"
              ),
            meta: { id: 6, hidden: true, name: "menu.TicketManage" }
          },

          {
            path: "/AIQualityInspection",
            name: "AI质检配置",
            component: () =>
              import(
                /* webpackChunkName: "property" */ "../views/order/AIQualityInspection/index.vue"
              ),
            meta: { id: 590, hidden: true, name: "dashbordDy.AIQualityInspectionConfiguration" },
            children: [
              {
                path: "/keywordLibrary",
                name: "关键词库",
                component: () =>
                  import(
                    /* webpackChunkName: "orderProperty" */ "../views/order/AIQualityInspection/keywordLibrary.vue"
                  ),
                meta: {
                  id: 591,
                  hidden: true,
                  name: "dashbordDy.Talkingpointlibrary"
                }
              },
              {
                path: "/addNewRules",
                name: "新建规则",
                component: () =>
                  import(
                    /* webpackChunkName: "orderProperty" */ "../views/order/AIQualityInspection/addNewRules.vue"
                  ),
                meta: {
                  id:'',
                  hidden: true,
                  name: "dashbordDy.addNewRules"
                }
              },
              {
                path: "/addNewTemplate",
                name: "新建质检模板",
                component: () =>
                  import(
                    /* webpackChunkName: "orderProperty" */ "../views/order/AIQualityInspection/addNewTemplate.vue"
                  ),
                meta: {
                  id:'',
                  hidden: true,
                  name: "dashbordDy.QualityInspectionTemplate"
                }
              },
              {
                path: "/QualityInspectionRules",
                name: "质检规则",
                component: () =>
                  import(
                    /* webpackChunkName: "combinationProperty" */ "../views/order/AIQualityInspection/QualityInspectionRules.vue"
                  ),
                meta: {
                  id: 592,
                  hidden: true,
                  name: "dashbordDy.QualityInspectionRules"
                }
              },
              {
                path: "/QualityInspectionTemplate",
                name: "质检模板",
                component: () =>
                  import(
                    /* webpackChunkName: "loadAttrConfig" */ "../views/order/AIQualityInspection/QualityInspectionTemplate.vue"
                  ),
                meta: {
                  id: 593,
                  hidden: true,
                  name: "dashbordDy.QualityInspectionTemplate"
                }
              },
            ]
          },


          {
            path: "/property",
            name: "属性配置",
            component: () =>
              import(
                /* webpackChunkName: "property" */ "../views/order/property/index.vue"
              ),
            meta: { id: 13, hidden: true, name: "menu.AttributeConfigure" },
            children: [
              {
                path: "/orderProperty",
                name: "工单基础属性",
                component: () =>
                  import(
                    /* webpackChunkName: "orderProperty" */ "../views/order/property/OrderProperty.vue"
                  ),
                meta: {
                  id: 14,
                  hidden: true,
                  name: "menu.TicketBasicAttribute"
                }
              },
              {
                path: "/combinationProperty",
                name: "工单组合属性",
                component: () =>
                  import(
                    /* webpackChunkName: "combinationProperty" */ "../views/order/property/CombinationProperty.vue"
                  ),
                meta: {
                  id: 15,
                  hidden: true,
                  name: "menu.TicketCombineAttribute"
                }
              },
              {
                path: "/loadAttrConfig",
                name: "负载属性配置",
                component: () =>
                  import(
                    /* webpackChunkName: "loadAttrConfig" */ "../views/order/property/LoadAttrConfig.vue"
                  ),
                meta: {
                  id: 19,
                  hidden: true,
                  name: "menu.LoadAttributeConfigure"
                }
              },
              {
                path: "/staffBasicProperty",
                name: "员工基础属性",
                component: () =>
                  import(
                    /* webpackChunkName: "orderProperty" */ "../views/order/property/StaffBasicProperty.vue"
                  ),
                meta: { id: 86, hidden: true, name: "menu.StaffBasicProperty" }
              },
              {
                path: "/staffCombProperty",
                name: "员工组合属性",
                component: () =>
                  import(
                    /* webpackChunkName: "combinationProperty" */ "../views/order/property/StaffCombProperty.vue"
                  ),
                meta: { id: 88, hidden: true, name: "menu.StaffCombProperty" }
              }
            ]
          },
          {
            path: "/rules",
            name: "规则配置",
            component: () =>
              import(
                /* webpackChunkName: "rules" */ "../views/order/rules/index.vue"
              ),
            meta: { id: 23, hidden: true, name: "menu.RuleConfiguration" },
            children: [
              {
                path: "/makeRules",
                name: "生成规则",
                component: () =>
                  import(
                    /* webpackChunkName: "makeRules" */ "../views/order/rules/MakeRules.vue"
                  ),
                meta: { id: 24, hidden: true, name: "menu.GenerationRule" }
              },
              {
                path: "/distributeRules",
                name: "分配规则",
                component: () =>
                  import(
                    /* webpackChunkName: "distributeRules" */ "../views/order/rules/DistributeRules.vue"
                  ),
                meta: { id: 25, hidden: true, name: "menu.DistributionRules" }
              },
              {
                path: "/recycleRules",
                name: "回收规则",
                component: () =>
                  import(
                    /* webpackChunkName: "recycleRules" */ "../views/order/rules/RecycleRules.vue"
                  ),
                meta: { id: 29, hidden: true, name: "menu.RecyclingRules" }
              },
              {
                path: "/OutsourceRules",
                name: "委外规则",
                component: () =>
                  import(
                    /* webpackChunkName: "OutsourceRules" */ "../views/order/rules/OutsourceRules.vue"
                  ),
                meta: { id: 33, hidden: true, name: "menu.OutsourcingRules" }
              },
            ]
          },
          {
            path: "/recotdingOrderDeal",
            name: "录音质检工单管理",
            component: () =>
              import(
                /* webpackChunkName: "orderDeal" */ "../views/order/recotdingOrderDeal.vue"
              ),
            meta: {
              // id: 475,测外
              id: 496,
              hidden: true,
              name: "menu.QualityInspectionRecording"
            }
          },
          {
            path: "/orderDeal",
            name: "工单处理列表",
            component: () =>
              import(
                /* webpackChunkName: "orderDeal" */ "../views/order/orderDeal/index.vue"
              ),
            meta: {
              id: 37,
              hidden: true,
              name: "menu.WorkOrderProcessingList"
            },
            children: [
              {
                path: "/collection",
                name: "催收",
                component: () =>
                  import(
                    /* webpackChunkName: "collection" */ "../views/order/orderDeal/Collection.vue"
                  ),
                meta: { id: 38, hidden: true, name: "menu.Collection" }
              },
              {
                path: "/RecordingQuality",
                name: "录音质检列表",
                component: () =>
                  import(
                    /* webpackChunkName: "RecordingQuality" */ "../views/order/RecordingQuality.vue"
                  ),
                meta: { 
                  // id:480,测外
                  id: 497, 
                  hidden: true, name: "menu.RecordingQuality" }
              },
              {
                path: "/recordingDail",
                name: "录音详情",
                component: () =>
                  import(
                    /* webpackChunkName: "collectionDetail" */ "../views/order/recordingDail.vue"
                  ),
                meta: { hidden: true, name: "" }
              },
              {
                path: "/repaymentRemind",
                name: "还款提醒",
                component: () =>
                  import(
                    /* webpackChunkName: "repaymentRemind" */ "../views/order/orderDeal/RepaymentRemind.vue"
                  ),
                meta: { id: 39, hidden: true, name: "menu.RepaymentReminder" }
              },
              {
                path: "/collectionDetail",
                name: "催收详情",
                component: () =>
                  import(
                    /* webpackChunkName: "collectionDetail" */ "../views/order/orderDeal/CollectionDetail.vue"
                  ),
                meta: { hidden: true, name: "" }
              }
            ]
          },
          {
            path: "/CorpusAnnotation",
            name: "语料标注",
            component: () =>
              import(
                /* webpackChunkName: "orderDeal" */ "../views/CorpusAnnotation/index.vue"
              ),
            meta: {
              id: 637,
              hidden: true,
              name: "menu.CorpusAnnotation"
            },
            children: [
              {
                path: "/CorpusAnnotation",
                name: "语料标注工单管理",
                component: () =>
                  import(
                    /* webpackChunkName: "collection" */ "../views/CorpusAnnotation/CorpusAnnotationTicketList.vue"
                  ),
                meta: { id: 638, hidden: true, name: "ticket.systemManager" }
              },
              {
                path: "/CorpusAnnotationDetail",
                name: "语料标注详情",
                component: () =>
                  import(
                    /* webpackChunkName: "RecordingQuality" */ "../views/CorpusAnnotation/CorpusAnnotationDetail.vue"
                  ),
                meta: { 
                  // id:480,测外
                  // id: 39, 
                  hidden: true, name: "menu.CorpusAnnotationDetail" }
              },
              {
                path: "/CorpusAnnotationList",
                name: "语料标注列表",
                component: () =>
                  import(
                    /* webpackChunkName: "RecordingQuality" */ "../views/CorpusAnnotation/CorpusAnnotationList.vue"
                  ),
                meta: { 
                  // id:480,测外
                  id: 639, 
                  hidden: true, name: "menu.CorpusAnnotationList" }
              },
            ]
          },
          {
            path: "/ticketEstimate",
            name: "单量估计",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/order/TicketEstimate.vue"
              ),
            meta: { id: 202, hidden: true, name: "Ticket Estimation" }
          },
          {
            path: "/paymentCodeInquire",
            name: "还款码查询",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/order/paymentCode/paymentCodeInquire.vue"
              ),
            meta: {
              id: 222,
              hidden: true,
              name: "menu.PaymentCodeInquire",
              keepAlive: true,
              back: false
            }
          },
          {
            path: "/paymentCodeHistory",
            name: "还款码历史",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/order/paymentCode/paymentCodeHistory.vue"
              ),
            meta: {
              id: 2221,
              hidden: true,
              name: "menu.PaymentCodeHistory",
              keepAlive: false,
              back: true
            }
          },
          ...orderPage,

        ]
      },
      {
        path: "/telemarketingTicketSystem",
        name: "电销工单系统",
        component: () =>
          import(/* webpackChunkName: "order" */ "../views/telemarketingTicketSystem/index.vue"),
        meta: { id: 454, hidden: true, name: "menu.TelemarketingTicketSystem" },
        children: [
          ...phoneSaleDataModule,
          {
            path: "/distributionRules",
            name: "电销分单",
            component: () =>
              import(
                /* webpackChunkName: "telemarketingTicketSystem" */ "../views/telemarketingTicketSystem/distributionRules.vue"
              ),
            meta: { id: 455, hidden: true, name: "menuLgy.DistributionRules" }
          },
          {
            path: "/salesOrderManagement",
            name: "电销工单管理",
            component: () =>
              import(
                /* webpackChunkName: "telemarketingTicketSystem" */ "../views/telemarketingTicketSystem/orderManagement/index.vue"
              ),
            meta: { id: 457, hidden: true, name: "ticket.systemManager" }
          },
          {
            path: "/orderHandleList",
            name: "电销工单处理列表",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/telemarketingTicketSystem/orderHandleList/index.vue"
              ),
            meta: { id: 456, hidden: true, name: "menu.WorkOrderProcessingList" },


          },
          {
            path: "/orderHandleDetail",
            name: "工单详情",
            component: () =>
              import(
                /* webpackChunkName: "oderHandleDetail" */ "../views/telemarketingTicketSystem/orderHandleList/orderHandleDetail.vue"
              ),
            meta: { hidden: true, name: "" }
          }

        ]
      },
      {
        path: "/approveManagement",
        name: "审核管理",
        component: () =>
          import(
            /* webpackChunkName: "approveManagement" */ "../views/approveManagement/index.vue"
          ),
        meta: { hidden: true, name: "menu.UserManagement" },
        children: [
          {
            path: "/apply",
            name: "我的申请",
            component: () =>
              import(
                /* webpackChunkName: "apply" */ "../views/approveManagement/Apply.vue"
              )
          }
        ]
      },
      {
        path: "/WhatsAppmange",
        name: "whatsAPP管理",
        component: () =>
          import(/* webpackChunkName: "order" */ "../views/WhatsApp/index.vue"),
        meta: { id: 621, hidden: true, name: "menu.WhatsAppManage" },
        children: [
          {
            path: "/whatsAppLogin",
            name: "whatsAPP账号管理",       
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/WhatsApp/whatsAppLogin.vue"
              ),
            meta: { id: 622, hidden: true, name: "menu.WhatsAppLogin" }
          },
          {
            path: "/whatsAppChat",
            name: "whatsAPP聊天",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/WhatsApp/whatsAppChat.vue"
              ),
            meta: { id: 630, hidden: true, name: "menu.WhatsAppChat" }
          }
          
        ]
      },
      {
        path: "/dialer",
        name: "Dialer管理",
        component: () =>
          import(/* webpackChunkName: "dialer" */ "../views/dialer/index.vue"),
        meta: { id: 40, hidden: true, name: "menu.DialerManagement" },
        children: [...voipExtension,
        {
          path: "/automaticOutgoingCall",
          name: "自动外呼记录",
          component: () =>
            import(
                /* webpackChunkName: "monitorIndex" */ "../views/dialer/AutomaticOutgoingCallRecord.vue"
            ),
          meta: { id: 237, hidden: true, name: "ticket.AutomaticOutgoingCallRecord" }
        },
        
        {
          path: "/callSequence",
          name: "呼叫顺序配置",
          component: () =>
            import(
                /* webpackChunkName: "monitorIndex" */ "../views/dialer/callSequence.vue"
            ),
          meta: { id: 282, hidden: true, name: "menuLgy.CallSequenceConfiguration" }
        },
        ]
      },
      {
        path: "/annotation",
        name: "标注助手",
        component: () =>import("../views/annotation/index.vue"),
        meta: { id: 487, hidden: true, name: "annotation.AnnotationManagement" },
        children: [
        {
          path: "/annotationManagement",
          name: "标注工单管理",
          component: () =>import("../views/annotation/index.vue"),
          meta: { id: 535, hidden: true, name: "annotation.AnnotationTicketManagement" }
        },
        {
          path: "/annotationList",
          name: "标注工单列表",
          component: () =>import("../views/annotation/index.vue"),
          meta: { id: 489, hidden: true, name: "annotation.AnnotationTicketList" }
        },
        {
          path: "/annotationImgDetail",
          name: "标注详情",
          component: function () {
            return Promise.resolve().then(function () { return require("../views/annotation/imgDetail.vue"); });
          },
          meta: { hidden: true, name: "" }
        }
        ]
      },
      {
        path: "/PerformanceManagement",
        name: "报表系统",
        component: () =>
          import(
            /* webpackChunkName: "PerformanceManagement" */ "../views/PerformanceManagement/index.vue"
          ),
        meta: { id: 77, hidden: true, name: "Reporting system" },
        children: [...PerformanceManagement]
      },
      {
        path: "/customerInfo",
        name: "客户信息",
        component: () =>
          import(
            /* webpackChunkName: "customerInfo" */ "../views/customerInfo/index.vue"
          ),
        meta: { hidden: true, name: "" }
      },
      {
        path: "/monitor",
        name: "催收控制系统",
        component: () =>
          import(
            /* webpackChunkName: "monitor" */ "../views/monitor/index.vue"
          ),
        meta: { hidden: true, name: "" },
        children: [
          {
            path: "/monitorIndex",
            name: "监控指标",
            component: () =>
              import(
                /* webpackChunkName: "monitorIndex" */ "../views/monitor/MonitorIndex.vue"
              ),
            meta: { hidden: true, name: "" }
          },
          {
            path: "/monitorReport",
            name: "监控报表",
            component: () =>
              import(
                /* webpackChunkName: "monitorReport" */ "../views/monitor/MonitorReport.vue"
              ),
            meta: { hidden: true, name: "" }
          }
        ]
      },
      {
        path: "/taskIndex",
        name: "任务管理系统",
        component: () =>
          import(
            /* webpackChunkName: "taskIndex" */ "../views/taskManagement/index.vue"
          ),
        meta: { hidden: true, name: "" },
        children: [
          {
            path: "/smsTask",
            name: "短信任务",
            component: () =>
              import(
                /* webpackChunkName: "smsTask" */ "../views/taskManagement/SMSTask.vue"
              ),
            meta: { hidden: true, name: "" }
          },
          {
            path: "/outboundTask",
            name: "外呼任务",
            component: () =>
              import(
                /* webpackChunkName: "outboundTask" */ "../views/taskManagement/OutboundTask.vue"
              ),
            meta: { hidden: true, name: "" }
          }
        ]
      },

      {
        path: "/taskManage",
        name: "任务管理",
        component: () =>
          import(
            "../views/taskManage/index.vue"
          ),
        meta: { id: 272, hidden: true, name: "robotFhb.taskManagement" },
        children: [
          {
            path: "/outboundPilotManage",
            name: "预测试外呼",
            component: () =>
              import(
                "../views/taskManage/outboundPilot/index.vue"
              ),
            meta: { id: 274, hidden: true, name: "预测试外呼" }
          },
          {
            path: "/robot",
            name: "机器人任务",
            component: () =>
              import(
                "../views/taskManage/robot/index.vue"
              ),
            meta: { id: 273, hidden: true, name: "robotFhb.robotService" }
          },
          {
            path: "/multilingual",
            name: "多语言内容管理",
            component: () =>
              import(
                "../views/taskManage/multilingual/index.vue"
              ),
            meta: { id: 653, hidden: true, name: "smsPushTask.multiContentManage" },
          },
          {
            path: "/multilingualContent",
            name: "添加多语言",
            component: () =>
              import(
                "../views/taskManage/multilingual/multilingualContent.vue"
              ),
            meta: { hidden: false, name: "" }
          },
        ]
      },
      {
        path: "/logging",
        name: "日志记录",
        component: () =>
          import(
            "../views/logging/index.vue"
          ),
        meta: { id: 418, hidden: true, name: "menu.LoggingManagement" },
        children: [
          {
            path: "/systemLog",
            name: "系统操作日志",
            component: () =>
              import(
                "../views/logging/systemLog/index.vue"
              ),
            meta: {
              id: 419, hidden: true, name: "menu.SystemOperationLog"
            }
          },
          {
            path: "/OTTHLog",
            name: "三方请求日志",
            component: () =>
              import(
                "../views/logging/OTTHLog/index.vue"
              ),
            meta: {
              id: 420, hidden: true, name: "menu.ThirdPartyRequestLog"
            }
          },
        ]
      },
      
       {
        path: "/ocrAnnotation",
        name: "OCR标注管理",
        component: () =>
          import(/* webpackChunkName: "order" */ "../views/ocrAnnotation/index.vue"),
        meta: { id: 535, hidden: true, name: "menu.OCRannotationmanagement" },
        children: [
          {
            path: "/OCRManagementList",
            name: "OCR工单列表",
            component: () =>
              import(
                /* webpackChunkName: "orderManagement" */ "../views/ocrAnnotation/OCRManagementList.vue"
              ),
            meta: { id: 541, hidden: true, name: "menu.OCRTicketList" }
          },
          {
            path: "/OCRprocessing",
            name: "OCR工单处理",
            component: () =>
              import(
                /* webpackChunkName: "property" */ "../views/ocrAnnotation/OCRprocessing/index.vue"
              ),
            meta: { id: 542, hidden: true, name: "menuFhb.workOrderProcessingList" },
            children: [
              {
                path: "/OCRlist",
                name: "OCR列表",
                component: () =>
                  import(
                    /* webpackChunkName: "orderProperty" */ "../views/ocrAnnotation/OCRprocessing/OCRlist.vue"
                  ),
                meta: {
                  id: 543,
                  hidden: true,
                  name: "menu.OCRlist"
                }
              },
            ]
          },
          
        ]
      },
      

    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/common/Login.vue")
  },
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  //   base: process.env.BASE_URL,
  routes: asyncRouterMap
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: string) {
  const origin: any = originalPush.call(this, location);
  return origin.catch((err: any) => err);
};
router.beforeEach((to, from, next) => {
  if (from.meta.back) {
    to.meta.keepAlive = true;
  } else {
    from.meta.keepAlive = false;
  }
  next();
});

export default router;
